export default __webpack_public_path__ + "static/media/left-arrow.f65d1c8e.svg";